import { Form, Formik } from 'formik'
import { isEmpty } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import Modal from 'rsuite/Modal'
import { StateParamsModel } from 'src/app/modules/common/Model'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import * as user from 'src/app/modules/userMgmt'
import * as departmentRedux from 'src/app/modules/userMgmt/components/departments'
import useGetBranchById, { useGetBranch } from 'src/app/queries/location/branches'
import useGetProvinceOptions from 'src/app/queries/location/province'
import FormCheckbox from 'src/cms/helpers/components/forms/FormCheckbox'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as Yup from 'yup'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

interface Province {
  id: string
  title: string
  titleNp: string
  code: number
}

interface BranchWithProvince {
  province: Province
}

interface Branch {
  id?: string
}

export interface User {
  name: string
  branch_id: string
  userName: string
  email: string
  mobile_number: string
  departmentId: string
  grievance_manager: boolean
  vendor: boolean
  provinces: string | string[] | { id: string }[]
  branches: string | string[] | { id: string }[]
}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
  userName: Yup.string()
    .required('Username is required')
    .matches(/^[a-zA-Z0-9_ ]+$/, 'Must not contain any symbol'),
  email: Yup.string()
    .required('Email is required')
    .email('Please provide valid email')
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Please provide valid email'),
  mobile_number: Yup.string()
    .required('Mobile No. is required')
    .matches(/^(98|97)([0-9]{8})$/, 'Enter valid phone number')
    .max(10, 'Phone number should not exceed 10 digits'),
  // branch_id: Yup.string().required('Main Branch is required.'),
  // branches: Yup.array()
  //   .min(1, 'At least one branch must be selected')
  //   .of(Yup.string().required('Branch is required'))
  //   .required('Please select at least one branch'),
})

export interface IOption {
  label: string
  value: string
}

const AddUser = ({ open, params, handleClose, actionType, editSelectedData }: Props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { loading, success } = useSelector((state: any) => state.userManagement)
  const { data: provinceOptions } = useGetProvinceOptions()

  const [branchParams, setBranchParams] = useState({
    search: '',
    page: 1,
    limit: 500,
    orderBy: '',
    order: '',
  })

  const [provinceId, setProvinceId] = useState<Array<number>>([])

  const { data: branchOption } = useGetBranch(branchParams)

  // const {data: branchOptions} = useGetBranchById(provinceId)
  const {
    data: { department },
  } = useSelector((state: any) => state.departments)

  useEffect(() => {
    dispatch(departmentRedux.actions.getDepartment())
  }, [])

  const departmentOptions = department.map((items: { [key: string]: string }) => ({
    label: items.name,
    value: items.id,
  }))

  useEffect(() => {
    if (success) {
      dispatch(user?.actions.getUsers(params))
      isEmpty(editSelectedData)
        ? toast.success('User added successfully')
        : toast.success('User edited successfully')
      dispatch(user?.actions?.resetUsers())
      handleClose()
    }
  }, [success])

  const newData = [
    {
      id: '271186de-d42f-4ceb-ad21-808da87e6b9f',
      label: 'title',
      name: 'Titlte (EN)',
      settingType: 'Contact',
      type: 'input',
      value: 'Head Office',
    },
  ]
  const multiLanguage = checkMultiLanguage()
  return (
    <div className='modal-container' data-cy='modal-user-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} User </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                name: '',
                userName: '',
                email: '',
                mobile_number: '',
                departmentId: '',
                grievance_manager: false,
                is_admin: false,
                vendor: false,
                provinces: [],
                branch_id: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values) => {
                const payload = {
                  ...values,
                  provinces: values?.provinces?.map((province) => ({ id: province })),
                  // branches: values?.branches?.map((branch) => ({ id: branch })),
                }

                if (!isEmpty(editSelectedData)) {
                  dispatch(user.actions.updateUsers(payload, editSelectedData?.id))
                } else {
                  dispatch(user.actions.addUsers(payload))
                }
              }}
            >
              {({ touched, handleChange, errors, setFieldValue, values }) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    // Populate initial values for provinces and branches
                    const initialProvinces = editSelectedData?.provinces?.map(
                      (item: any) => item.province_id ?? item?.id
                    )
                    const initialBranches = editSelectedData?.branches?.map(
                      (item: any) => item.branch_id ?? item?.id
                    )

                    // const result = provinceOptions
                    //   ?.filter((item: any) => initialProvinces.includes(item.value))
                    //   ?.map((item: any) => item.code)

                    // setProvinceId(result)
                    const fields = [
                      'name',
                      'userName',
                      'email',
                      'mobile_number',
                      'departmentId',
                      'grievance_manager',
                      'vendor',
                      'is_admin',
                      'provinces',
                      'branch_id',
                    ]
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                    setFieldValue('provinces', initialProvinces, false)
                    // setFieldValue('branches', initialBranches, false)
                  }
                }, [])

                // useEffect(() => {
                //   const allIds = branchOptions?.map((item: any) => item?.value).splice(1)

                //   if (values?.branches?.some((option) => option === 'all')) {
                //     setFieldValue('branches', allIds)
                //   }
                // }, [values?.branches])
                return (
                  <Form>
                    <div className='card-body border-top pt-5' data-cy='card-user-body'>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            containerClassName='col-md-12'
                            type='text'
                            placeholder='Full Name'
                            label='Name'
                            name='name'
                            disabled={!isEmpty(editSelectedData) ? true : false}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                            data-cy='add-user-full-name-text-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            containerClassName='col-md-12'
                            type='text'
                            placeholder='Username'
                            label='Username'
                            name='userName'
                            disabled={!isEmpty(editSelectedData) ? true : false}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                            data-cy='add-user-name-text-field'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            containerClassName='col-md-12'
                            type='email'
                            placeholder='Email'
                            name='email'
                            disabled={!isEmpty(editSelectedData) ? true : false}
                            label='Email'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                            value={values?.email}
                            data-cy='add-user-name-email-field'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12 pb-0 mb-0'>
                          <FormTextBox
                            containerClassName='col-12'
                            type='text'
                            placeholder='Enter Mobile Number'
                            label='Mobile Number'
                            name='mobile_number'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                            data-cy='add-user-number-text-field'
                          />
                          <div className='d-flex justify-content-end'>
                            <em>
                              <small className='d-block'>
                                <span className='text-danger' data-cy='text-user-danger'>
                                  Note:{' '}
                                </span>{' '}
                                Mobile number should starts with 98|97
                              </small>
                            </em>
                          </div>
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Department'
                            name='departmentId'
                            isClearable={true}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={departmentOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                            arrValue={
                              !isEmpty(editSelectedData) && !values.departmentId
                                ? editSelectedData?.departmentId
                                : values.departmentId
                            }
                            data-cy='add-user-department-dropdown-field'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Province'
                            name='provinces'
                            isClearable={true}
                            multiple={true}
                            onChange={(event: any) => {
                              const selectIds = event?.map((item: any) => item?.code)
                              setProvinceId(selectIds)
                            }}
                            errors={errors}
                            touched={touched}
                            options={provinceOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                        {/* <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Branches'
                            name='branches'
                            isClearable={true}
                            multiple={true}
                            errors={errors}
                            touched={touched}
                            options={
                              branchOption?.data?.branch?.map((item: any) => ({
                                label: item?.title,
                                value: item?.id,
                              })) || []
                            }
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div> */}
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Branch'
                            name='branch_id'
                            isClearable={true}
                            // multiple={true}
                            errors={errors}
                            touched={touched}
                            options={
                              branchOption?.data?.branch?.map((item: any) => ({
                                label: item?.title,
                                value: item?.id,
                              })) || []
                            }
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                        {multiLanguage ? null : (
                          <div>
                            <div className='col-lg-4'>
                              <FormCheckbox
                                labelClassName='col-md-12 pb-3'
                                containerClassName='col-md-12'
                                label='Grievance Manager'
                                name='grievance_manager'
                                touched={touched}
                                errors={errors as any}
                                onChange={handleChange}
                                checkBoxText='Is Grievance Officer ?'
                                checked={values?.grievance_manager}
                                data-cy='add-user-grevance-manager-check-box'
                              />
                            </div>
                            <div className='col-lg-4'>
                              <FormCheckbox
                                labelClassName='col-md-12 pb-3'
                                containerClassName='col-md-12'
                                label='Vendor'
                                name='vendor'
                                touched={touched}
                                errors={errors as any}
                                onChange={handleChange}
                                checkBoxText='Is Vendor ?'
                                checked={values?.vendor}
                                data-cy='add-user-vender-check-box'
                              />
                            </div>
                            <div className='col-lg-4'>
                              <FormCheckbox
                                labelClassName='col-md-12 pb-3'
                                containerClassName='col-md-12'
                                label='Is Admin ?'
                                name='is_admin'
                                touched={touched}
                                errors={errors as any}
                                onChange={handleChange}
                                checkBoxText='Is Admin ?'
                                checked={editSelectedData?.is_admin}
                                data-cy='add-user-is-admin-check-box'
                              />
                            </div>
                          </div>
                        )}

                        <div className='d-flex justify-content-end px-9 '>
                          <button
                            type='submit'
                            disabled={loading}
                            className='btn btn-primary btn-sm ms-3'
                            data-cy='modal-submit'
                          >
                            Save
                          </button>
                          <button
                            type='button'
                            onClick={handleClose}
                            className='btn btn-secondary btn-sm ms-3'
                            data-cy='modal-cancel'
                          >
                            Cancel
                          </button>
                        </div>
                      </div>{' '}
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AddUser
